import axios from 'axios';
import store from '../store';

// POST LOGIN => API/TOKEN
export const login = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("loginRequest");
    axios
      .post(store.getters.getAddress + "token", payload)
      .then(response => {
        const auth = response.data;
        commit("setLanguage", response.data.language);
        axios.defaults.headers.common['Authorization'] = `Bearer ${
          auth.access_token
          }`;
        commit("loginSuccess", auth);
        resolve(response);
      })
      .catch(error => {
        commit("loginError");
        delete axios.defaults.headers.common['Authorization'];
        reject(error.response);
      });
  });
}

// POST REGISTER => API/ACCOUNT
export const register = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .post(store.getters.getAddress + "account", payload)
      .then(response => {
        commit("registerSuccess");
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// LOGOUT
export const logout = ({ commit }) => {
  commit("logout");
  delete axios.defaults.headers.common["Authorization"];
}

// GET USERS=> API/USERS
export const getUsers = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "users")
      .then(response => {
        commit("getUsers", response.data);
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// EDIT USER SETTINGS
export const useredit = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .put(store.getters.getAddress + "user/settings", payload)
      .then(response => {
        commit("registerSuccess");
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// GET USER LANGUAGE
export const userLanguage = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "user/getlanguage")
      .then(response => {
        store.state.language = response.data;
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// CHANGE USERS LANGUAGE
export const changeLanguage = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .put(store.getters.getAddress + "user/language/" + payload.l)
      .then(response => {
        store.state.language = payload.l;
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET PROJECTS=> API/PROJECT/ALL
export const getProjects = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "project/all")
      .then(response => {
        commit("getProjects", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET PROJECTS PER USER => API/PROJECT/ALL/id
export const getProjectsPerUser = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "project/all/" + payload)
      .then(response => {
        commit("getProjects", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// PUT PROJECT => API/PROJECT
export const projectedit = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .put(store.getters.getAddress + "project", payload)
      .then(response => {
        commit("registerSuccess");
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// POST PROJECT => API/PROJECT
export const projectcreate = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .post(store.getters.getAddress + "project", payload)
      .then(response => {
        commit("registerSuccess");
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// COPY PROJECT => API/PROJECT/COPY
export const projectcopy = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(store.getters.getAddress + "project/copy", payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  })
}

// DELETE PROJECT => API/PROJECT/id
export const projectdelete = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .delete(store.getters.getAddress + "project/" + payload.Id)
      .then(response => {
        commit("registerSuccess");
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// POST SELUSERS
export const selectusers = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(store.getters.getAddress + "sharedprojects", payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET WINDOWS=> API/WINDOW/ALL
export const getwindows = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .get(store.getters.getAddress + "window/all/" + payload)
      .then(response => {
        commit("getWindows", response.data);
        commit("registerSuccess");
        resolve(response.data);
      })
      .catch(error => {
        commit("noWindowsFound");
        commit("registerError");
        reject(error.response);
      });
  });
}

// POST WINDOW => API/WINDOW
export const windowpost = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .post(store.getters.getAddress + "window", payload)
      .then(response => {
        commit("windowCreateResponse", response.data);
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// PUT WINDOW => API/WINDOW
export const windowedit = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("registerRequest");
    axios
      .put(store.getters.getAddress + "window", payload)
      .then(response => {
        commit("windowCreateResponse", response.data);
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// DELETE WINDOW => API/WINDOW/id
export const windowdelete = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(store.getters.getAddress + "window/" + payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        commit("registerError");
        reject(error.response);
      });
  });
}

// GET BOM => API/BOM/id
export const windowbom = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "BOM/" + payload)
      .then(response => {
        commit("getBom", response.data);
        resolve(response);
      })
      .catch(error => {
        commit("noWindowsFound");
        reject(error.response);
      });
  });
}

export const getHandles = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "handle")
      .then(response => {
        commit("getHandles", response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getMotors = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "motor")
      .then(response => {
        commit("getMotors", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getProfiles = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "profile")
      .then(response => {
        commit("getProfiles", response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getInvisitopProfiles = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "invisitopprofile")
      .then(response => {
        commit("getInvisitopProfiles", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getTranslations = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "translation")
      .then(response => {
        commit("getTranslations", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getVersions = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "version/list")
      .then(response => {
        commit("getVersions", response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getSharedUsers = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "sharedusers")
      .then(response => {
        commit("setSharedUsers", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getSharedProjects = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "sharedprojects")
      .then(response => {
        commit("setSharedProjects", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getProjUsers = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "sharedprojects/" + payload.id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getUser = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "sharedusers/getuser/" + payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const deleteUser = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(store.getters.getAddress + "sharedusers/" + payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const getVersion = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .get(store.getters.getAddress + "version")
      .then(response => {
        commit("setVersion", response.data.version);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}


export const setversion = ({ commit }) => {
  return new Promise((reject) => {
    axios
      .put(store.getters.getAddress + "version/setversion")
      .then(response => {
        commit("setVersions", response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export const projectcsv = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("projectCSVRequest");
    axios({
      url: store.getters.getAddress + 'project/bom/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      commit("projectCSVSuccess");
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      const prj = getters.getProjectById(payload);
      a.href = url;
      a.download = prj.customerName + " - " + prj.projectName + '.csv';
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  });
}

export const projectxl = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("projectCSVRequest");
    axios({
      url: store.getters.getAddress + 'project/bom/xl/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      commit("projectCSVSuccess");
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      const prj = getters.getProjectById(payload);
      a.href = url;
      a.download = prj.customerName + " - " + prj.projectName + '.xlsx';
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  });
}

export const windowcsv = ({ state, getters }, payload) => {
  return new Promise((resolve, reject) => {
    axios({
      url: store.getters.getAddress + 'bom/csv/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      const win = getters.getWindowById(payload);
      a.href = url;
      a.download = state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].csv';
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  });
}

export const windowxl = ({ state, getters }, payload) => {
  return new Promise((resolve, reject) => {
    axios({
      url: store.getters.getAddress + 'bom/xl/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      const win = getters.getWindowById(payload);
      a.href = url;
      a.download = state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].xlsx';
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  });
}

export const windowpdf_ORIGINAL = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("pdfRequest");
    axios({
      url: store.getters.getAddress + 'window/pdf/' + payload,
      method: 'GET',
      responseType: 'arraybuffer'
    })
      .then(response => {
        commit("pdfSuccess");
        const contentDisposition = response.request.getResponseHeader('Content-Disposition');

        let fileName = 'unknown';
        var fn = contentDisposition.split(";");
        var file = fn[1];
        file = file.trim();
        file = file.replace(/"/g, '');
        file = file.replace(/filename=/, '');

        const blob = new File([response.data], file);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.download = file;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
  });
}

export const windowpdf = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("pdfRequest");
    axios({
      url: store.getters.getAddress + 'window/pdf/' + payload.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      commit("pdfSuccess");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const win = getters.getWindowById(payload.id);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
      document.body.appendChild(link);
      link.click();
      resolve(response);
    });
  });
}

export const projectwindowpdf = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {

    axios({
      url: store.getters.getAddress + 'window/pdf/' + payload.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const win = getters.getWindowById(payload.id);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
      document.body.appendChild(link);
      link.click();
      resolve(response);
    });
  });
}

export const genericpdf = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("pdfRequest");
    axios({
      url: store.getters.getAddress + 'genericdrawing/pdf/' + payload,
      method: 'GET',
      responseType: 'blob'
    })
      .then(response => {
        commit("pdfSuccess");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const win = getters.getWindowById(payload);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'GENERIC_' + state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf';
        link.setAttribute('download', 'GENERIC_' + state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
        document.body.appendChild(link);
        link.click();
      })
  });
}

export const projectpdf = ({ state, getters, commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit("projectPDFRequest");
    axios({
      url: store.getters.getAddress + 'project/pdf/' + payload.proj.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      commit("projectPDFSuccess");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.proj.customerName + " - " + payload.proj.projectName + ".pdf");
      document.body.appendChild(link);
      link.click();
    });
  });
}

export const exportOrgaData = ({ state, getters }) => {
  return new Promise((resolve, reject) => {
    axios({
      url: store.getters.getAddress + 'system/export/orgadata/',
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      a.href = url;
      a.download = "export.xlsx";
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  });
}

export const uploadfile = ({ state, getters, commit, resolve }, payload) => {
  return new Promise((resolve, reject) => {
    commit("fileUploadRequest");
    axios.post(store.getters.getAddress + 'window/upload/' + state.project.id,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then((function (response) {
      commit("setErrorList", response);
      commit("fileUploadSuccess");
      resolve(response);
    }))
      .catch(function () {
        console.log('Invalid file');
      });
  })
}

export const getGenericDownloads = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "genericdownloads/all")
      .then(response => {
        commit("getGenericDownloads", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// Password reset
export const pwreset = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(store.getters.getAddress + "token/pwreset/", payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// Password change
export const pwchange = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(store.getters.getAddress + "token/pwchange/", payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET COUNTRIES=> API/COUNTRIES
export const getCountries = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "countries")
      .then(response => {
        commit("setCountries", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET LANGUAGES=> API/LANGUAGES
export const getLanguages = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "languages")
      .then(response => {
        commit("setLanguages", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

// GET SYSCOS=> API/SYSCOS
export const getSysCos = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(store.getters.getAddress + "syscos")
      .then(response => {
        commit("setSysCos", response.data);
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}


// WEBPACK FOOTER //
// ./src/ClientApp/store/actions.js